import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { FormProvider } from './context/FormContext';
import { captureUrlParameters } from './lib/urlTracker';
import { logger } from './lib/utils';
import AppRoutes from './components/AppRoutes';
import TrackingScripts from './components/TrackingScripts';
import './App.css';
import './index.css';
import './styles/form.css';

const App: React.FC = () => {
  useEffect(() => {
    // Capture URL parameters on first visit
    captureUrlParameters();

    // Log environment variables for debugging
    logger.log('App init - VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL || 'undefined');
    logger.log('App init - VITE_SUPABASE_ANON_KEY exists:', !!import.meta.env.VITE_SUPABASE_ANON_KEY);
  }, []);

  return (
    <Router>
      <FormProvider>
        {/* Initialize tracking scripts */}
        <TrackingScripts />
        <AppRoutes />
      </FormProvider>
    </Router>
  );
};

export default App;
